<template>
  <el-dialog v-dialogDrag :visible.sync="dlgVisible" :close-on-click-modal="false"
    :close-on-press-escape="false" title="添加专业" width="500px">
    <el-form ref="specForm" size="small" :model="specForm" label-position="left" label-width="100px">
      <el-form-item label="专业编号" prop="specId" :rules="[{ required: true, message: '请输入专业编号' }]">
        <el-input ref="specId" v-model="specForm.specId" maxlength="10" show-word-limit />
        <p class="tips">提示：只能是大写字母、数字、下划线、点，长度不超过 10</p>
      </el-form-item>
      <el-form-item label="专业名称" prop="specName" :rules="[{ required: true, message: '请输入专业名称' }]">
        <el-input ref="specName" v-model="specForm.specName" maxlength="25" show-word-limit />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dlgVisible = false">取 消</el-button>
      <el-button v-preventReClick type="primary" size="small" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>

import { mapState } from "vuex";
import priviService from '@/CommonDP/service/privi-service';

const DEFAULT_FORM = {
  specId: "",
  specName: ""
};

export default {
  data() {
    return {
      dlgVisible: false,
      specForm: {
        ...DEFAULT_FORM
      }
    };
  },

  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  methods: {
    async showDlg() {
      this.dlgVisible = true;
      this.specForm = { ...DEFAULT_FORM };
      await this.$nextTick();
      this.$refs.specId.focus();
      this.$refs.specForm.clearValidate();
    },

    async submit() {
      try {
        await this.$refs.specForm.validate();
        const specIdValid = /^[A-Z0-9\.\_]*$/.test(this.specForm.specId);
        if (!specIdValid) {
          this.$error("请输入正确的专业编号");
          return;
        }
        this.specForm.enterpriseId = this.enterpriseId;
        const res = await priviService.addPrjSpec(this.specForm);
        this.$success("专业添加成功");
        this.dlgVisible = false;
        this.$emit("ok", res.data);
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style scoped>
.tips {
  color: gray;
  font-size: 0.9em;
}
</style>
